<template>
<f7-list accordion-list v-if="invoices" id="invoices-item-received" class="itemList">
  <f7-accordion-item class="accordionForm"
    v-for="invoice in invoices"
    :key="invoice.IdInvoice">
    <f7-accordion-toggle class="accordionToggle">
      <ul>
        <li class="swipeout" style="background: #dcdcdc;">
          <div class="item-content boxRequest">
            <div class="item-media">
              <div id="greenRectangle" :style="{background: rectangleColor}"></div>
              <i class="icon list-icon" :class="getIcon(invoice.Status)"></i>
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <table width="100%" style="table-layout: fixed;">
                  <tr>
                    <td style="width: 43%; min-width: 43%; max-width: 43%;" class="showLargeScreenOnly">
                      <div style="font-weight: bold;">
                        {{ invoice.NameSeller }}
                      </div>
                      <div class="showSmallScreenOnly">
                        {{ $t('common.amnt') + ': ' + invoice.Amount + ' €' }}
                      </div>
                      <div class="showSmallScreenOnly statusLabel">
                        {{ $t('common.exec_date') + ' ' }} {{ invoice.PaymentDate | formatDate }}
                      </div>
                      <div class="showSmallScreenOnly" style="font-size: 12px;">
                        {{ $t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier }}
                      </div>
                    </td>
                    <td style="width: 100%;" class="showSmallScreenOnly">
                      <div style="font-weight: bold;">
                        {{ invoice.NameSeller }}
                      </div>
                      <div class="showSmallScreenOnly">
                        {{ $t('common.amnt') + ': ' + invoice.Amount + ' €' }}
                      </div>
                      <div class="showSmallScreenOnly statusLabel">
                        {{ $t('common.exec_date') + ' ' }} {{ invoice.PaymentDate | formatDate }}
                      </div>
                      <div class="showSmallScreenOnly" style="font-size: 12px;">
                        {{ $t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier }}
                      </div>
                    </td>
                    <td style="width: 25%; min-width: 25%; max-width: 25%;" class="showLargeScreenOnly">
                      {{ $t('common.amnt') + ': ' + invoice.Amount + ' €' }}
                    </td>
                    <td style="text-align: right;" class="showLargeScreenOnly">
                      <div style="color: #8e8e93;">
                        {{ $t('common.exec_date') + ' ' }} {{ invoice.PaymentDate | formatDate }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="statusLabel">
                      {{ getStatusLabel(invoice.Status) }}
                    </td>
                    <td>
                    </td>
                    <td style="font-size: 12px; text-align: right;" class="showLargeScreenOnly">
                      {{ $t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </f7-accordion-toggle>
    <f7-accordion-content class="background-document-form left-box">
      <invoice-details
        class="container-document-form" :invoice="invoice"
        :showMainDetails="showInvoiceMainDetails">
      </invoice-details>
    </f7-accordion-content>
  </f7-accordion-item>
</f7-list>
</template>

<script>
import InvoiceDetailCapsule from './InvoiceDetailCapsule.vue'
import {statusLabel, statusIcon} from '@/helpers/labels'

export default {
  name: 'InvoicesList',
  props: ['invoices', 'showInvoiceMainDetails'],
  components: {
    'invoice-details': InvoiceDetailCapsule
  },
  data () {
    return {
      rectangleColor: this.$engine.services.getServiceColor('6')
    }
  },
  methods: {
    getIcon (status) {
      return statusIcon('Invoice_' + status)
    },
    getStatusLabel (status) {
      return statusLabel(this.$i18n, 'Invoice_' + status)
    }
  }
}
</script>
